import { render, staticRenderFns } from "./ScreensTable.vue?vue&type=template&id=5d40cf44"
import script from "./ScreensTable.vue?vue&type=script&lang=js"
export * from "./ScreensTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d40cf44')) {
      api.createRecord('5d40cf44', component.options)
    } else {
      api.reload('5d40cf44', component.options)
    }
    module.hot.accept("./ScreensTable.vue?vue&type=template&id=5d40cf44", function () {
      api.rerender('5d40cf44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screens-table/ScreensTable.vue"
export default component.exports